export const environment = {
  production: true,
  apiUrl:'/api/',
  uploadUrl:'/',
  uploadTempUrl:'/temp/',
  signalrHubUrl:'/'
};
